import React from 'react';
import { colors as dsColors, mediaQuery } from '@modernhealth/vital-foundation';
import { useMediaQuery } from '@react-hook/media-query';
import styled from '@emotion/styled';
import {
    ComponentTextSmall,
    ComponentTextXSmall,
    HeadingText30,
    HeadingText40,
    Button,
    pxToRem,
} from '@modernhealth/vital-components';

const Container = styled.div({
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    gap: pxToRem(28),
    position: 'relative',
    width: '100%',
    minHeight: pxToRem(120),
    marginTop: pxToRem(20),
    marginBottom: pxToRem(48),
    borderStyle: 'solid',
    borderWidth: pxToRem(1),
    borderRadius: pxToRem(8),
    borderColor: dsColors.gray05,
});

const TextContainer = styled.div({
    display: 'flex',
    flexBasis: '75%',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: pxToRem(4),
});

const ImageContainer = styled.div({
    overflow: 'hidden',
    flexBasis: '25%',
    bottom: 0,
    left: 0,
    marginLeft: pxToRem(24),
    width: '40%',
    maxWidth: pxToRem(108),
    maxHeight: '100%',

    [mediaQuery.maxWidth('md')]: {
        maxWidth: pxToRem(50),
    },

    '.image': {
        width: '90%',
        marginTop: pxToRem(8),
    },
});

const ButtonContainer = styled.div({
    width: '18%',
});

interface BannerCardProps {
    title: string;
    description: string;
    imageSrc: string;
    buttonCopy: string;
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const BannerCard: React.FC<BannerCardProps> = ({
    title,
    description,
    imageSrc,
    buttonCopy,
    onClick,
}) => {
    const smallScreenDetected = useMediaQuery(mediaQuery.maxWidth('md', true));
    const TitleTextComponent = smallScreenDetected ? HeadingText30 : HeadingText40;
    const SubtitleTextComponent = smallScreenDetected ? ComponentTextXSmall : ComponentTextSmall;

    return (
        <Container>
            <ImageContainer>
                <img src={imageSrc} className="image" alt={title} />
            </ImageContainer>

            <TextContainer>
                <TitleTextComponent fontColor="black">{title}</TitleTextComponent>
                <SubtitleTextComponent fontColor="gray65" marginBottom={8}>
                    {description}
                </SubtitleTextComponent>
            </TextContainer>
            <ButtonContainer>
                <Button size="medium" variant="primary" rounded onClick={onClick}>
                    {buttonCopy}
                </Button>
            </ButtonContainer>
        </Container>
    );
};

export default BannerCard;
